<template>
  <div class="flex flex-col dark:text-zinc-300 my-5 md:my-0 md:justify-self-center">
    <p class="text-black dark:text-zinc-300 text-base font-semibold">Links Rápidos</p>
    <NuxtLink to="/blog" class="hover:underline"> Home </NuxtLink>
    <NuxtLink to="/blog/posts" class="hover:underline"> Posts </NuxtLink>
    <NuxtLink to="/blog/tags" class="hover:underline"> Tags </NuxtLink>
  </div>
</template>
